import React from 'react';
import { motion } from 'framer-motion';
interface Props {
  children: React.ReactNode;
  className?: string;
  variant?: 'light' | 'dark';
  hover?: boolean;
  delay?: number;
}
export function Card({
  children,
  className = '',
  variant = 'light',
  hover = false,
  delay = 0
}: Props) {
  const base = variant === 'dark' ? 'bg-navy-800/60 border-white/10 backdrop-blur-sm' : 'bg-white border-slate-200';
  return <motion.div initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.55,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} whileHover={hover ? {
    y: -3
  } : undefined} className={`border rounded-md ${base} ${hover ? 'transition-shadow hover:shadow-[0_8px_30px_rgb(10,22,40,0.08)]' : ''} ${className}`} data-id="element-654">
      {children}
    </motion.div>;
}